import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Image,
  Table,
  Button,
  Modal,
} from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import BasicPagination from "../../Pagination/Pagination";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
// import { IconButton } from "@material-ui/core";
import moment from "moment";
import { MenuItem, Menu } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SmallLoader } from "../../../components/Loader/SmallLoader";
import {
  get_all_vendor_earnings,
  get_all_history_earnings,
} from "../../../store/actions/VendorEarnings/vendorEarningsActions";
import isEmpty from "../../../store/validation/is-Empty";
import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import SelectFilter from "../../reusableComponents/selectFilter";
// import { Menu, MenuItem } from "@material-ui/core";
// import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../reusableComponents/NoContentComponent";
export const Earnings = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  /**********************************
   * @DESC FIRST TIME API CALL
   *********************************/
  useEffect(() => {
    const token = props.auth.user.accessToken;
    dispatch(
      get_all_vendor_earnings(
        token,
        dateQuery?.startDate || moment().format("YYYY-MM-DD"),
        dateQuery?.endDate || moment().format("YYYY-MM-DD")
      )
    );
  }, [dateQuery]);

  /**************************************
   * @DESC SET ALL VENDOR EARNINGS DATA
   **************************************/
  const [vendorEarningsData, setVendorEarningsData] = useState([]);
  useEffect(() => {
    setVendorEarningsData(props.getAllVendorEarningsData);
  }, [props.getAllVendorEarningsData]);

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    sortBy: "",
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  /**********************************************
   * @DESC SEARCH BY BANK NAME, ACCOUNT, AMOUNT
   *********************************************/
  const onSearchClick = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*************************
   * @DESC SORT BY NAME
   ************************/
  const userFilter = [
    { title: "Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /*************************
   * @DESC FILTTER SEARCH
   ************************/
  const [showFilter, setShowFilter] = useState(false);
  const [sort, setSort] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [filter, setFilter] = useState({
    status: "",
    type: "",
    search: false,
  });

  const handleShowFilter = () => {
    setShowFilter(true);
  };
  const searchClick = () => {
    setShowFilter(false);
  };
  const cancelClick = () => {
    setShowFilter(false);
  };

  /************************************
   * @DESC SORT, FILTER, AND SEARCH
   ************************************/
  let filteredData = vendorEarningsData?.settlements;
  if (state.sortBy === "A-Z") {
    filteredData = vendorEarningsData?.settlements.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  } else if (state.sortBy === "Z-A") {
    filteredData = vendorEarningsData?.settlements.sort((a, b) => {
      if (a.name < b.name) return 1;
      if (a.name > b.name) return -1;
      return 0;
    });
  }
  if (sort === "Low to High 🠑") {
    filteredData = filteredData.sort(
      (a, b) => a.settlement_amount - b.settlement_amount
    );
  } else if (sort === "High to Low 🠓") {
    filteredData = filteredData.sort(
      (a, b) => b.settlement_amount - a.settlement_amount
    );
  }

  if (state.search) {
    let searchData = new RegExp(state.search, "i");
    filteredData = vendorEarningsData?.settlements.filter((getall) => {
      if (searchData.test(getall.settlement_account_details?.bankName)) {
        return getall;
      } else if (
        searchData.test(getall.settlement_account_details?.account_number)
      ) {
        return getall;
      } else {
        return false;
      }
    });
  }
  console.log(typeof filteredData, "filterdata");

  const onViewClickHistory = (id) => () => {
    const token = props.auth.user.accessToken;
    dispatch(get_all_history_earnings(token, id, onSuccess));
  };

  const onSuccess = (settlementId) => {
    history.push({
      pathname: `/earnings/payouthistory/${settlementId}`,
      state: { payoutId: settlementId },
    });
  };

  if (filter?.status === 1) {
    filteredData = filteredData?.filter((item) => {
      return item?.settle_payment_status === 1;
    });
  } else if (filter?.status === 2) {
    filteredData = filteredData?.filter((item) => {
      return item?.settle_payment_status === 0;
    });
  }

  /*****************************************
   * @DESC Download Button Action
   ****************************************/
  const downloadData = {
    headers: [
      { label: "Settlement Date & Time", key: "settlementdate" },
      { label: "Settlement Type", key: "settlemettype" },
      { label: "Amount To Be Settled", key: "amount" },
      { label: "Amealio Commission", key: "commision" },
      { label: "Status", key: "status" },
    ],
    data:
      filteredData?.map((downdata) => {
        return {
          settlementdate: `${moment(downdata?.payoutStartDate).format(
            "Do MMM, YYYY"
          )} \n ${moment(downdata?.payoutStartDate).format("hh:mm A")}`,
          settlemettype: `${downdata?.payout_type === 0
            ? "ordering"
            : downdata?.payout_type === 1
              ? "Tips"
              : downdata?.payout_type === 2
                ? "Events"
                : "Scan & pay"
            }`,
          amount: downdata?.settlement_amount,
          commision: downdata?.totalEarnedComission,
          status: `${downdata?.settle_payment_status === 1 ? "settled" : "unsettled"
            }`,
        };
      }) || [],
  };
  const renderEarningsAccordian = () => {
    return (
      filteredData?.length ?
        filteredData.map((data, index) => (
          <TableBodyMobile
            key={index}
            data={data}
            onClickViewAction={(id) => onViewClickHistory(id)}
            index={index}
          // startDate={startDate}
          // endDate={endDate}
          />
        )) : <NoContent />
    );
  };
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="super_admin_add_vendor mb-4">
                    <h5 className="main_header_text">
                      Earnings
                    </h5>
                  </div>
                  <div className="text-right" align="right">
                    <div className="f12-400">Report Run Date: {moment().format("Do MMM, YYYY")}</div>
                    <div className="d-flex mt-2">
                      <div className="f12-400">Report Range Date :</div>
                      <div className="f12-700 ml-2">
                        {moment(dateQuery?.startDate).format("Do MMM, YYYY")} {"-"}{" "}
                        {moment(dateQuery?.endDate).format("Do MMM, YYYY")}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-6 text-right">
                      <button
                        onClick={(e) => {
                          history.push("/addcategory");
                        }}
                        className="btn add_button_custom_1"
                      >
                        + Add Category
                      </button>
                    </div> */}

                <Row className="align-items-center">
                  <Col lg={4} md={5} xs={9} className="pl-0">
                    <div className="d-flex align-items-center">
                      <Image
                        onClick={() =>
                          // this.setState({ showSearch: !this.state.showSearch })
                          setShowSearch(!showSearch)
                        }
                        alt="Search"
                        title="Search"
                        width="80px"
                        src={require("../../../assets/images/iconButton/newsearchicon.svg")}
                      />


                      <div
                        className="f10-400"
                        align="center"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <img
                          src={require("../../../assets/images/iconButton/sortbtn.svg")}
                          width="80px"
                          title="Sort"
                          alt="sorticon"
                        />
                      </div>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {userFilter.map((ele, index) => {
                          return (
                            <MenuItem
                              value={ele.title}
                              key={index}
                              onClick={() => setSort(ele.title)}
                              disabled={ele.disabled}
                            >
                              {ele.title}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                      <div
                        className="f10-400"
                        align="center"
                      >
                        <img
                          src={require("../../../assets/images/iconButton/filterbtn.svg")}
                          width="80px"
                          alt="Filter Icon"
                          onClick={() => setShowFilter(!showFilter)}
                        />
                      </div>
                      <div className="f10-400" align="center">
                        <CSVDownloader
                          filename={"Offers-Summary-Report"}
                          headers={downloadData.headers}
                          data={downloadData.data}
                        />
                      </div>


                    </div>
                  </Col>
                  <Col lg={5}></Col>
                  <Col lg={3} className="d-flex justify-content-end">
                    <div className="mr-3">
                      <SelectFilter onDateChange={onDateChangeHandler()} />
                    </div>
                  </Col>
                </Row>
                {showSearch && (
                  <>
                    <div className="filter-button-search">
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        // value
                        onChange={(e) => onSearchClick(e)}
                        value={state.search}
                        className="amSearch w-100"
                      />
                    </div>
                  </>
                )
                }
                <Row>
                  <Col md={3} xs={6}>
                    <div className="d-flex main-component-itemsforsellement">
                      <div
                        className="mr-3 p-2"
                        style={{ background: "white", borderRadius: "50%" }}
                      >
                        <img
                          src={require("../../../assets/images/superadmin/earnings.png")}
                          width="45px"
                        />
                      </div>
                      <div>
                        <div className="f18-700">
                          ₹{" "}
                          {vendorEarningsData?.totalEarning
                            ? vendorEarningsData?.totalEarning.toFixed(2)
                            : "0"}
                        </div>
                        <div className="f14-400">Total Earnings</div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Modal
                  show={showFilter}
                  onHide={() => setShowFilter(!showFilter)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Filter</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <FormTemp
                      showFilter={showFilter}
                      setShowFilter={setShowFilter}
                      onSubmit={(e) => setFilter({ ...filter, status: e })}
                    />
                  </Modal.Body>
                </Modal>
                {/* {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-pmethod">
                              Status
                            </InputLabel>
                            <Select
                              value={filter.status}
                              onChange={(e) =>
                                setFilter({ ...filter, status: e.target.value })
                              }
                              label="Status"
                              inputProps={{
                                name: "pmethod",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {[
                                { name: "Settled", value: true },
                                { name: "Un Settled", value: false },
                              ].map((ele) => (
                                <MenuItem value={ele.value} key={ele.value}>
                                  {ele.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            location: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )} */}
              </div>
              <Media query="(max-width: 991px)">
                <>
                  <div className="row seating-dashboard-table">
                    <div className="col-3 mpr-1">
                      <p className="f12-700 pl-3">Internal</p>
                    </div>
                    <div className="col-3 mpl-1 mpr-1">
                      <p className="f12-700">Total Amount</p>
                    </div>
                    <div className="col-3 mpl-1">
                      <p className="f12-700">Status</p>
                    </div>
                    <div className="col-3 mpl-1">
                      <p className="f12-700">Actions</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0">
                      <Accordion>{renderEarningsAccordian()}</Accordion>
                    </div>
                  </div>
                </>
              </Media>
              <Media query="(min-width: 991px)">
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table>
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>
                            Settlement <br /> Date & Time{" "}
                          </th>
                          <th style={{ width: "20%" }}>
                            Settlement <br />
                            Type
                          </th>
                          {/* <th style={{ width: "15%" }}>Bank Name</th>
                          <th style={{ width: "15%" }}>Account Number</th> */}
                          <th style={{ width: "20%" }}>
                            Amount to be <br />
                            Settled
                          </th>
                          <th style={{ width: "20%" }}>
                            Amealio
                            <br /> commission
                          </th>
                          <th style={{ width: "20%" }}>Status</th>
                          <th style={{ width: "20%" }}>Actions</th>
                        </tr>
                      </thead>
                      {/* <TableBody /> */}
                      {props.auth.secondary_loader ? (
                        <SmallLoader />
                      ) : (
                        filteredData?.length ?
                          filteredData.slice(start, end).map((data, index) => (
                            <TableBody
                              key={index}
                              data={data}
                              onClickViewAction={(id) => onViewClickHistory(id)}

                            // startDate={startDate}
                            // endDate={endDate}
                            />
                          ))
                          : <NoContent />
                      )}
                    </Table>
                  </div>
                </div>
              </Media>
              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={filteredData?.length || 0}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </Container>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </Row>
      </div>
    </React.Fragment>
  );
};

Earnings.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_vendor_earnings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  getAllVendorEarningsData: state.vendorEarnings.get_all_vendor_earnings,
});

export default connect(mapStateToProps, {
  get_all_vendor_earnings,
})(Earnings);

const TableBody = (props) => {
  const history = useHistory();
  // console.log(props.data,"********daaata*****")
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row">
                <td style={{ width: "20%" }}>
                  {props?.data.settle_payment_status === 1 ? (
                    <>
                      <div className="f12-500">
                        {moment(props.data?.createdAt).format("Do MMM, YYYY")}
                        <br />
                        {moment(props.data?.createdAt).format("hh:mm A")}
                      </div>
                    </>
                  ) : "-"}
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">
                    {props.data?.payout_type === 0
                      ? "ordering"
                      : props.data?.payout_type === 1
                        ? "Tips"
                        : props.data?.payout_type === 2
                          ? "Events"
                          : props.data?.payout_type === 3
                            ? "Scan & pay"
                            : "Experience"}
                  </div>
                </td>
                {/* <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {props.data?.settlement_account_details?.bankName}
                  </div>
                </td> */}
                {/* <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {props.data?.settlement_account_details?.account_number.replace(
                      /\d(?=\d{4})/g,
                      "*"
                    )}
                  </div>
                </td> */}

                <td style={{ width: "20%" }}>
                  <div className="f12-500">
                    ₹ {props.data?.settlement_amount.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">
                    ₹ {props.data?.totalEarnedComission.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "20%" }}>
                  {props?.data.settle_payment_status === 1 ? (
                    <div style={{ borderRadius: "20px" }} className="badge badge-success p-2">Settled</div>
                  ) : (
                    <div style={{ borderRadius: "20px" }} className="badge badge-warning p-2">Requested</div>
                  )}
                </td>
                <td style={{ width: "20%" }}>
                  <div className="d-flex align-items-center">
                    {/* <button
                      class="btn btn-danger btn-sm mr-2"
                      onClick={() => redirect(props.data, true)}
                    >
                      Initiate Payout
                    </button> */}
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      // onClick={() => {
                      //   history.push("/earnings/payouthistory");
                      // }}
                      //   onClick={() => redirect(props.data, false)}
                      onClick={props.onClickViewAction(props.data._id)}
                    >
                      <Image
                        src={require("../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyMobile = (props) => {
  return (
    <React.Fragment key={props?.index}>
      <Card className="main-reusable-accordion mt-1">
        <Accordion.Toggle as={Card.Header} eventKey={props?.index + 1}>
          <div className="d-flex align-items-center">
            <div className="card-header-left f10-500">
              {moment(props.data?.payoutStartDate).format("Do MMM, YYYY")}
              <br />
              {moment(props.data?.payoutStartDate).format("hh:mm A")}
            </div>
            <div className="card-header-middle f10-500">
              ₹ {props.data?.total_amount}
            </div>
            <div className="card-header-middle ml-2 f10-500">
              {props?.data.settle_payment_status === 1 ? (
                <div className="badge badge-success p-2">Settled</div>
              ) : (
                <div className="badge badge-warning p-2">Unsettled</div>
              )}
            </div>
            <div className="card-header-right f10-500 justify-content-center">
              <Button
                variant="link"
                className="enIconBtn mr-3"
                // onClick={() => {
                //   history.push("/earnings/payouthistory");
                // }}
                //   onClick={() => redirect(props.data, false)}
                onClick={props.onClickViewAction(props.data._id)}
              >
                <Image
                  src={require("../../../assets/images/UserManagement/eye.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
            </div>
          </div>{" "}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={props?.index + 1}>
          <Card.Body>
            {/******* Section One *********/}
            <hr className="mt-0" />
            <div className="row">
              <div className="col-6 sectionone-left">
                <p className="f10-700 pb-2 opacity5">Payout Amount</p>

                <div className="f12-400">
                  {props?.data &&
                    props?.data.diner_id &&
                    props?.data.diner_id.user_details.name}
                </div>
              </div>
              <div className="col-5 sectionone-middle ">
                <p className="f10-700 pb-2 opacity5">Admin Commission</p>
                <div className="f10-400">-</div>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </React.Fragment>
  );
};

const FormTemp = (props) => {
  const [filter, setFilter] = useState(0);
  const filterSetValue = (e) => {
    setFilter(e);
    props.onSubmit(e);
  };
  return (
    <div className="f12-500">
      Select one relevent option from below
      <br />
      <div className="pt-4 d-flex flex-wrap align-items-center">
        <button
          type="button"
          className={`enFilterButton mr-3 mb-3 ${filter === 0 ? "active" : ""}`}
          onClick={() => filterSetValue(0)}
        >
          All
        </button>
        <button
          type="button"
          className={`enFilterButton mr-3 mb-3 ${filter === 1 ? "active" : ""}`}
          onClick={() => filterSetValue(1)}
        >
          Settled
        </button>
        <button
          type="button"
          className={`enFilterButton mr-3 mb-3 ${filter === 2 ? "active" : ""}`}
          onClick={() => filterSetValue(2)}
        >
          Un Settled
        </button>
      </div>
      <div className="d-flex justify-content-end mt-2">
        <Button
          className="btn btn-outline-secondary mr-2"
          onClick={() => filterSetValue(0)}
        >
          Reset Filter
        </Button>
        <Button
          className="btn btn-danger"
          onClick={() => props.setShowFilter(!props.showFilter)}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};
